// "use client";

import Image from "next/image";
import Link from "next/link";
// import { useEffect, useState, useMemo } from "react";
import { useEffect, useState, useMemo } from "react";

import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

import { ModeToggle } from "../darkModeToggler/DarkModeToggler";
import "./style.css";
import SocialIcons from "../socialIcons/SocialIcons";
import { useTheme } from "next-themes";
import CryptoMarquee from "../cryptoMarquee/CryptoMarquee";
import Offcanvas from "react-bootstrap/Offcanvas";
import { usePathname } from "next/navigation";
import type { MenuItem } from "@/types/menu";
import { usePageType } from "@/lib/pageTypeContext";

export interface MenuResponse {
  data: MenuItem[];
}

// Only truly non-menu utility pages go here
const HARDCODED_STATIC_PAGES = new Set([
  "/",
  "/advertising",
  "/contact-us",
  "/about-us",
  "/terms-of-services",
  "/privacy-and-policy",
  "/sitemap",
  "/donation",
  "/scam",
]);

const ensureAbsolute = (url?: string) => {
  if (!url || url === "location not found") return "/";
  if (url.startsWith("/") || url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }
  return `/${url}`;
};

export default function SubHeader({
  menu,
  authorSlugs = [],
}: {
  menu: MenuItem[];
  authorSlugs?: string[];
}) {
  const [mounted, setMounted] = useState(false);
  // const [menuData, setMenuData] = useState<MenuItem[]>([]);
  const [showMenu, setShowMenu] = useState(false);
  const [openItem, setOpenItem] = useState<string | null>(null);
  const [isTransparent, setIsTransparent] = useState(true);
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  // const [menuLoaded, setMenuLoaded] = useState(false);
  // const [isAuthorPage, setIsAuthorPage] = useState(false);

  const menuData: MenuItem[] = Array.isArray(menu) ? menu : [];
  const menuLoaded = true;

  const { resolvedTheme } = useTheme();
  const pathname = usePathname();
  const isHomePage = pathname === "/";
  const { pageType } = usePageType();
  const isAuthorPage = pageType === "author";

  // Derive static pages dynamically from menu API data
  // const STATIC_PAGES = useMemo(() => {
  //   const menuSlugs = menuData
  //     .filter((item) => item.item_visibility === "1")
  //     .map((item) => {
  //       const slug = item.item_slug;
  //       if (!slug) return null;
  //       // Normalize: ensure leading slash, strip trailing slash
  //       return slug.startsWith("/") ? slug : `/${slug}`;
  //     })
  //     .filter(Boolean) as string[];

  //   return new Set([...HARDCODED_STATIC_PAGES, ...menuSlugs]);
  // }, [menuData]);

  const STATIC_PAGES = useMemo(() => {
    const menuSlugs = menuData
      .filter((item) => item.item_visibility === "1")
      .map((item) => {
        const slug = item.item_slug;
        if (!slug) return null;
        return slug.startsWith("/") ? slug : `/${slug}`;
      })
      .filter(Boolean) as string[];

    return new Set([...HARDCODED_STATIC_PAGES, ...menuSlugs]);
  }, [menuData]);

  // Single useEffect for mount
  useEffect(() => {
    setMounted(true);
  }, []);

  const isDark = mounted ? resolvedTheme === "dark" : false;

  // Mark loaded after fetch
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const res = await fetch("/api/menu");
  //       const result: MenuResponse = await res.json();
  //       setMenuData(result.data || []);
  //     } catch (error) {
  //       console.error(error);
  //     } finally {
  //       setMenuLoaded(true); // ← add this
  //     }
  //   };
  //   fetchData();
  // }, []);

  // Guard isDetailPage until menu is loaded
  // const isDetailPage =
  //   menuLoaded && // ← wait for menu
  //   !!pathname &&
  //   pathname.split("/").filter(Boolean).length === 1 &&
  //   !STATIC_PAGES.has(pathname);

  const isDetailPage =
    menuLoaded &&
    !!pathname &&
    !isAuthorPage &&
    pathname.split("/").filter(Boolean).length === 1 &&
    !STATIC_PAGES.has(pathname);

  const isHeroTransparent = mounted && isTransparent && isDetailPage;
  const forceHeroStyle = isDetailPage && isTransparent;

  const navLinkColor: string = forceHeroStyle
    ? "#fff"
    : mounted && isDark
      ? "#fff"
      : "#000";

  const logoSrc = forceHeroStyle
    ? "/logo/logo-light.png"
    : mounted && isDark
      ? "/logo/logo-light.png"
      : "/logo/logo-dark.png";

  const hamWhite = `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 1%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e")`;
  const hamBlack = `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.75%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e")`;
  const hamIcon = forceHeroStyle || (mounted && isDark) ? hamWhite : hamBlack;

  const dropdownShadow = isDark
    ? "0 8px 30px rgba(0,0,0,0.7), 0 2px 8px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.06)"
    : "0 8px 30px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.08), 0 0 0 1px rgba(0,0,0,0.06)";

  useEffect(() => {
    setMounted(true);
  }, []);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const res = await fetch("/api/menu");
  //       const result: MenuResponse = await res.json();
  //       setMenuData(result.data || []);
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   };
  //   fetchData();
  // }, []);

  const parentMenus = menuData
    .filter(
      (item) =>
        item.item_parent_id === "0" &&
        item.item_visibility === "1" &&
        item.item_location === "main",
    )
    .sort((a, b) => Number(a.item_order) - Number(b.item_order));

  const toggleItem = (id: string) => {
    setOpenItem(openItem === id ? null : id);
  };

  useEffect(() => {
    const handleScroll = () => {
      const header = document.getElementById("gh-header");
      if (!header) return;
      if (window.scrollY >= 60) {
        header.classList.remove("transparent");
        setIsTransparent(false);
      } else {
        header.classList.add("transparent");
        setIsTransparent(true);
      }
      if (isDetailPage) {
        header.classList.add("detail-page");
      } else {
        header.classList.remove("detail-page");
      }
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isDetailPage]);

  return (
    <>
      <header className="d-lg-none">
        <CryptoMarquee isDark={isDark} />
      </header>

      <Navbar
        expand="lg"
        className={`gh-header py-2 border-bottom ps-2 ps-lg-0 fixed transparent ${isDetailPage ? "detail-page" : ""}`}
        id="gh-header"
      >
        <div className="gh-container px-0 px-lg-5">
          <div className="row w-100 align-items-center">
            {/* LEFT: Logo */}
            <div className="col-8 col-lg-3 d-flex align-items-center">
              <Link
                href="/"
                className="d-inline-flex align-items-center navbar-brand-link"
              >
                {/* Responsive logo wrapper — smaller on mobile, full size on desktop */}
                <div className="navbar-logo-wrapper">
                  <Image
                    src={logoSrc}
                    fill
                    style={{
                      objectFit: "contain",
                      objectPosition: "left center",
                    }}
                    alt="coinccino"
                    priority
                  />
                </div>
              </Link>
            </div>

            {/* Mobile: DarkToggle + Hamburger */}
            <div className="col-4 d-flex justify-content-end align-items-center gap-1 d-lg-none">
              <ModeToggle
                height="36px"
                width="36px"
                isTransparent={isHeroTransparent}
              />
              <button
                type="button"
                aria-label="Open navigation menu"
                onClick={() => setShowMenu(true)}
                className="border-0 d-lg-none"
                style={{
                  background: "transparent",
                  padding: "4px",
                  cursor: "pointer",
                  width: "36px",
                  height: "36px",
                  backgroundImage: hamIcon,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundSize: "1.5em",
                  flexShrink: 0,
                }}
              />
            </div>

            {/* Desktop Nav */}
            <Navbar.Collapse
              id="subheader-navbar-nav"
              className="col-12 col-lg-9 d-none d-lg-flex"
            >
              <div className="row w-100 align-items-center">
                <div className="col-lg-11 d-flex justify-content-center mt-2 mt-lg-0">
                  <Nav className="gap-3 align-items-center">
                    {parentMenus.map((parent) => {
                      const subItems =
                        menuData?.filter(
                          (sub) =>
                            String(sub.item_parent_id) ===
                            String(parent.item_id) &&
                            sub.item_visibility === "1",
                        ) || [];

                      if (subItems.length > 0) {
                        return (
                          <div
                            key={parent.item_id}
                            className="nav-item dropdown fw-medium"
                            onMouseEnter={() => setOpenDropdown(parent.item_id)}
                            onMouseLeave={() => setOpenDropdown(null)}
                            style={{ position: "relative" }}
                          >
                            <span
                              className="nav-link dropdown-toggle fw-medium"
                              style={{
                                cursor: "pointer",
                                whiteSpace: "nowrap",
                                color: navLinkColor,
                              }}
                            >
                              {parent.item_name}
                            </span>
                            {openDropdown === parent.item_id && (
                              <ul
                                className="dropdown-menu show"
                                style={{
                                  position: "absolute",
                                  top: "100%",
                                  left: 0,
                                  minWidth: "180px",
                                  boxShadow: dropdownShadow,
                                }}
                              >
                                <li>
                                  <Link
                                    href={ensureAbsolute(parent.item_slug)}
                                    className="dropdown-item fw-bold text-primary"
                                  >
                                    <span
                                      style={{
                                        position: "relative",
                                        display: "inline-block",
                                      }}
                                    >
                                      ALL
                                      <span className="dropdown-underline" />
                                    </span>
                                  </Link>
                                </li>
                                {subItems
                                  .sort(
                                    (a, b) =>
                                      Number(a.item_order) -
                                      Number(b.item_order),
                                  )
                                  .map((sub) => (
                                    <li key={sub.item_id}>
                                      <Link
                                        href={ensureAbsolute(sub.item_slug)}
                                        className="dropdown-item fw-bold"
                                      >
                                        <span
                                          style={{
                                            position: "relative",
                                            display: "inline-block",
                                          }}
                                        >
                                          {sub.item_name}
                                          <span className="dropdown-underline" />
                                        </span>
                                      </Link>
                                    </li>
                                  ))}
                              </ul>
                            )}
                          </div>
                        );
                      }

                      return (
                        <Nav.Link
                          key={parent.item_id}
                          as={Link}
                          href={parent.item_slug || "#"}
                          className="fw-medium p-0 gh-header-nav-link"
                          style={{ color: navLinkColor }}
                        >
                          {parent.item_name}
                        </Nav.Link>
                      );
                    })}
                  </Nav>
                </div>

                <div className="col-lg-1 d-flex justify-content-center justify-content-lg-end mt-2 mt-lg-0">
                  <ModeToggle isTransparent={isHeroTransparent} />
                </div>
              </div>
            </Navbar.Collapse>
          </div>
        </div>
      </Navbar>

      {/* Mobile Sidebar */}
      <div className="d-lg-none">
        <Offcanvas
          show={showMenu}
          onHide={() => setShowMenu(false)}
          placement="start"
          className={`mobile-sidebar ${isDark ? "sidebar-dark" : "sidebar-light"}`}
        >
          <Offcanvas.Header className="sidebar-header custom-offcanvas-header p-4">
            <button
              type="button"
              className="btn-close sidebar-close"
              aria-label="Close"
              onClick={() => setShowMenu(false)}
            />
            <div className="sidebar-logo">
              <Link href="/" className="d-inline-block">
                <Image
                  src={isDark ? "/logo/logo-light.png" : "/logo/logo-dark.png"}
                  alt="Logo"
                  width={140}
                  height={28}
                  priority
                  fetchPriority="high"
                />
              </Link>
            </div>
          </Offcanvas.Header>

          <Offcanvas.Body className="sidebar-body main-menu_block">
            <Nav className="flex-column sidebar-nav px-3">
              {parentMenus.map((parent) => {
                const subItems =
                  menuData?.filter(
                    (sub) =>
                      String(sub.item_parent_id) === String(parent.item_id) &&
                      sub.item_visibility === "1",
                  ) || [];

                const isOpen = openItem === parent.item_id;

                return (
                  <div key={parent.item_id} className="sidebar-item">
                    {subItems.length > 0 ? (
                      <button
                        className={`sidebar-link ${isDark ? "dark-text" : "light-text"}`}
                        onClick={() => toggleItem(parent.item_id)}
                      >
                        <span className={`toggle-icon ${isOpen ? "open" : ""}`}>
                          {isOpen ? "−" : "+"}
                        </span>
                        <span className="sidebar-item-name">
                          {parent.item_name}
                        </span>
                      </button>
                    ) : (
                      <Link
                        href={ensureAbsolute(parent.item_slug)}
                        className={`sidebar-link ${isDark ? "dark-text" : "light-text"}`}
                        onClick={() => setShowMenu(false)}
                      >
                        <span className="toggle-icon"></span>
                        <span className="sidebar-item-name">
                          {parent.item_name}
                        </span>
                      </Link>
                    )}

                    {subItems.length > 0 && (
                      <div className={`submenu ${isOpen ? "open" : ""}`}>
                        {subItems.map((sub) => (
                          <Link
                            key={sub.item_id}
                            href={ensureAbsolute(sub.item_slug)}
                            className={`submenu-link ${isDark ? "dark-text" : "light-text"}`}
                            onClick={() => setShowMenu(false)}
                          >
                            {sub.item_name}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </Nav>

            <div
              className={`sidebar-extra main-menu_block ${isDark ? "dark-text" : "light-text"}`}
            >
              <Nav className="flex-column gap-2 px-3">
                <Nav.Link
                  as={Link}
                  href="/advertising"
                  className={`${isDark ? "dark-text" : "light-text"} small fw-medium p-0`}
                >
                  Advertising
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  href="/contact-us"
                  className={`${isDark ? "dark-text" : "light-text"} small fw-medium p-0`}
                >
                  Contact Us
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  href="/about-us"
                  className={`${isDark ? "dark-text" : "light-text"} small fw-medium p-0`}
                >
                  About Us
                </Nav.Link>
              </Nav>
              <hr />
              <div className="sidebar-social main-menu_block px-5">
                <SocialIcons showLabel={true} />
              </div>
              <hr />
              <ModeToggle showLabel={true} />
              <hr />
              <div className="container text-center footer-copyright">
                <span className="footer-copyright-text">
                  Copyright 2025 ©️ Coinccino - All Rights Reserved.
                  <Link
                    className="footer-copyright-link"
                    href="/terms-of-services"
                  >
                    {" "}
                    Terms of Services
                  </Link>{" "}
                  &amp;{" "}
                  <Link
                    className="footer-copyright-link"
                    href="/privacy-and-policy"
                  >
                    {" "}
                    Privacy Policy
                  </Link>
                  .<br />
                </span>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </>
  );
}
